/* @flow */

import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NavIconSettingsWrench from './nav-icon-settings-wrench.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconSettingsWrench {...validProps} />;
}
SvgComponent.iconName = 'navIconSettingsWrench';

export const NavIconSettingsWrenchIcon = svgIconWrapper(SvgComponent);
